/**
 * -------------------------------------------------------------------------
 * App Entry Point (src/index.js)
 * -------------------------------------------------------------------------
 *
 * This is the main JavaScript entry point for the React application.
 * It's responsible for:
 * 1. Importing the main React libraries.
 * 2. Importing the global stylesheet.
 * 3. Importing the top-level React component (Root).
 * 4. Using the React 18 createRoot API to render the app into the
 * 'root' div in public/index.html.
 *
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Import the top-level Root component, which contains the entire application,
// including routing and context providers (from App.js).
import Root from './App';

// Find the 'root' DOM element in public/index.html.
// This is the target container where our React app will be mounted.
const rootElement = document.getElementById('root');

// Create a React 18 root. This new API enables concurrent features.
const root = ReactDOM.createRoot(rootElement);

// Render the application.
root.render(
  // React.StrictMode is a developer-only tool that wraps the application.
  // It runs additional checks and warnings (e.g., for deprecated lifecycles)
  // to help find potential problems during development. It does not
  // run in the production build.
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);